(function (root) {
  'use strict';
  function clock(now) {
    var result = {};
    new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23', weekday: 'short' }).formatToParts(now || new Date()).forEach(function (p) { if (p.type !== 'literal') result[p.type] = p.value; });
    return result;
  }
  function earliest(mode, now) {
    var p = clock(now), cutoff = mode === 'pickup' ? (p.weekday === 'Sat' ? 13 : 16) : 14;
    var next = p.weekday === 'Sun' || Number(p.hour) >= cutoff;
    var day = new Date(Date.UTC(Number(p.year), Number(p.month) - 1, Number(p.day) + (next ? 1 : 0)));
    if (day.getUTCDay() === 0) day.setUTCDate(day.getUTCDate() + 1);
    return day.toISOString().slice(0, 10);
  }
  function sunday(value) { return /^\d{4}-\d{2}-\d{2}$/.test(value || '') && new Date(value + 'T12:00:00Z').getUTCDay() === 0; }
  function zip(value) { var m = /^(\d{5})(?:-\d{4})?$/.exec((value || '').trim()); return m ? m[1] : ''; }
  function groupUpdates(items, key, quantity) {
    if (!Number.isInteger(quantity) || quantity < 0) throw new Error('quantity');
    var parent = items.find(function (item) { return item.key === key; });
    if (!parent) throw new Error('parent');
    var updates = {}, props = parent.properties || {};
    updates[parent.key] = quantity;
    if (props._bff_role === 'parent' && props._bff_group) items.forEach(function (item) {
      var info = item.properties || {};
      if (info._bff_group === props._bff_group && info._bff_role === 'extra') updates[item.key] = quantity;
    });
    return updates;
  }
  function selectedItems(parent, extraIds, group, title) {
    var quantity = Number(parent.quantity);
    if (!Number.isInteger(quantity) || quantity < 1 || !Number(parent.id)) throw new Error('selection');
    var props = Object.assign({}, parent.properties || {}, { _bff_group: group, _bff_role: 'parent' });
    var items = [{ id: Number(parent.id), quantity: quantity, properties: props }];
    Array.from(new Set(extraIds.filter(function (id) { return Number(id) > 0; }).map(Number))).forEach(function (id) {
      items.push({ id: id, quantity: quantity, properties: Object.assign({}, parent.properties || {}, { For: title, _bff_group: group, _bff_role: 'extra' }) });
    });
    return items;
  }
  root.BFFJourneyCore = { clock: clock, earliest: earliest, sunday: sunday, zip: zip, groupUpdates: groupUpdates, selectedItems: selectedItems };
})(typeof window === 'undefined' ? globalThis : window);
